/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Val_NutritionInputs */

const en_val_nutrition = /** @type {(inputs: Val_NutritionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nutrition`)
};

const es_val_nutrition = /** @type {(inputs: Val_NutritionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nutrición`)
};

const fr_val_nutrition = /** @type {(inputs: Val_NutritionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nutrition`)
};

const de_val_nutrition = /** @type {(inputs: Val_NutritionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ernährung`)
};

const ja_val_nutrition = /** @type {(inputs: Val_NutritionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`栄養指導`)
};

const zh_val_nutrition = /** @type {(inputs: Val_NutritionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`营养`)
};

const ar_val_nutrition = /** @type {(inputs: Val_NutritionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`تغذية`)
};

const id_val_nutrition = /** @type {(inputs: Val_NutritionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nutrisi`)
};

const it_val_nutrition = /** @type {(inputs: Val_NutritionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nutrizione`)
};

const ru_val_nutrition = /** @type {(inputs: Val_NutritionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Питание`)
};

const pt_val_nutrition = /** @type {(inputs: Val_NutritionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nutrição`)
};

const ko_val_nutrition = /** @type {(inputs: Val_NutritionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`영양/식단`)
};

/**
* | output |
* | --- |
* | "Nutrition" |
*
* @param {Val_NutritionInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const val_nutrition = /** @type {((inputs?: Val_NutritionInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Val_NutritionInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_val_nutrition(inputs)
	if (locale === "es") return es_val_nutrition(inputs)
	if (locale === "fr") return fr_val_nutrition(inputs)
	if (locale === "de") return de_val_nutrition(inputs)
	if (locale === "ja") return ja_val_nutrition(inputs)
	if (locale === "zh") return zh_val_nutrition(inputs)
	if (locale === "ar") return ar_val_nutrition(inputs)
	if (locale === "id") return id_val_nutrition(inputs)
	if (locale === "it") return it_val_nutrition(inputs)
	if (locale === "ru") return ru_val_nutrition(inputs)
	if (locale === "pt") return pt_val_nutrition(inputs)
	return ko_val_nutrition(inputs)
});